import { Controller } from "@hotwired/stimulus";

// Removes the closest alert element when the dismiss button is clicked.
// Usage: <div role="alert" data-controller="dismissible">
//          <button data-action="click->dismissible#dismiss" aria-label="Close">X</button>
//        </div>
export default class extends Controller {
  dismiss() {
    this.element.remove();
  }
}
